import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { refreshSubscription, type SubscriptionState } from "@/lib/stripe";

export const useSubscription = () => {
  const { user } = useAuth();
  const [state, setState] = useState<SubscriptionState | null>(null);
  const [loading, setLoading] = useState(true);

  const loadLocal = useCallback(async () => {
    if (!user) {
      setState(null);
      setLoading(false);
      return;
    }
    const { data } = await supabase
      .from("subscribers")
      .select("subscribed, subscription_status, subscription_tier, current_period_end")
      .eq("user_id", user.id)
      .maybeSingle();
    setState(
      data ?? { subscribed: false },
    );
    setLoading(false);
  }, [user]);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const fresh = await refreshSubscription();
      setState(fresh);
    } catch {
      await loadLocal();
    } finally {
      setLoading(false);
    }
  }, [loadLocal]);

  useEffect(() => {
    loadLocal();
  }, [loadLocal]);

  return {
    ...(state ?? { subscribed: false }),
    loading,
    refresh,
    isPro: !!state?.subscribed,
  };
};
